export default "__VITE_ASSET__o1qM1zbg__"